<cmx-spinner *ngIf="profileStatePrices?.loadingPrices" [size]="'40'" [descriptionShow]="true"></cmx-spinner>
<div class="text-right" *ngIf="profileStatePrices">
  <span
    class="cmx-icon-edit font-bright-blue"
    aria-hidden="true"
    (click)="editPrices()"
    [attr.data-tid]="'edit-one-click-prices'"
  ></span>
</div>
<div class="row justify-content-end" *ngIf="price">
  <div class="col-md-4 font-weight-bold">
    <div>{{ 'views.checkout.subtotal' | translate }}:</div>
    <div>{{ 'views.checkout.taxes' | translate }}:</div>
  </div>
  <div class="col-md-2">
    <div>{{ price.netValue | formatCurrency }}</div>
    <div>{{ price.taxes | formatCurrency }}</div>
  </div>
  <div class="col-md-12 mt-3">
    <h2>{{ 'views.one_click.total' | translate }}: {{ price.subTotal | formatCurrency }}</h2>
  </div>
  <p class="mr-3 mt-2" *ngIf="profileStatePrices.applyCharges">
    <span class="cmx-icon-warning-rounded-fill" aria-hidden="true"></span>
    {{ 'views.one_click.profile_additional_charges' | translate }}
  </p>
</div>
<cwc-button
  class="mt-4 float-right"
  data-tid="cmx-createoneclickprofile-btngetprices"
  cmx-button
  (click)="getPrices()"
  [disabled]="!isReadyForPrices || profileStatePrices?.loadingPrices"
  designVersion="v2"
>
  {{ 'views.one_click.get_prices' | translate }}
</cwc-button>
